// extracted by mini-css-extract-plugin
export default {"wrap":"transform-notice__wrap__mq"};